export const environment = {
    production: false,
    shippingApiUrl: 'https://tyx-webapp-shippingservice-qa.azurewebsites.net',
    accountsApiUrl: 'https://api-qa.transnetyx.com/accounts/v1/registration/user-info',
    
    auth0: {
        domain: 'login-qa.transnetyx.com',
        clientId: 'YQXX9hNjhNqPotg1KK28Zz0XwazWkmQJ',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-qa.transnetyx.com/v2/logout/quick-order`,
        logoutUrl: 'https://login-qa.transnetyx.com/v2/logout',
    },

    colonyUrl: 'https://colony-qa.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-qa.transnetyx.com',
    geneticMonitoringUrl: 'https://quickorder-qa.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome/home',
    ordersUrl: 'https://quickorder-qa.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder-qa.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder-qa.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts-qa.transnetyx.com/Account/Details',
    quickorderSettingsUrl: 'https://quickorder-qa.transnetyx.com/Account.aspx',
    billingSettingsUrl: 'https://quickorder-qa.transnetyx.com/OrderSearch.aspx',
    messageSettingsUrl: 'https://quickorder-qa.transnetyx.com/EmailPreferences.aspx',
    orderSearchUrl: 'https://quickorder-qa.transnetyx.com/OrderSearch.aspx',
};
